module.exports = __webpack_public_path__ + "static/media/weight-loss.884e7c84.svg";